<template>
    <div class="block">
        <a href="#" :class="isLoad ? 'title open':'title' " @click.prevent="getEventsPupils">Посещенные обучающимися проектных классов</a>
        <transition name="fade">
        <div class="content" v-if="isLoad">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>Название мероприятия для обучающихся</th>
                    <th>Организация, проводившая мероприятие</th>
                    <th style="min-width: 105px;">Дата<br/> проведения</th>
                    <th>Уровень образования</th>
                    <th>Кол-во участников (всего)</th>
                    <th>Количество победителей (при наличии)</th>
                    <th>Количество призёров (при наличии)</th>
                </tr>
                </thead>
                <tbody v-if="eventsPupils">
                    <tr v-bind:key="item.id" v-for="item in eventsPupils">
                        <td>{{item.name}}</td>
                        <td>{{item.organization}}</td>
                        <td :text-content.prop="timestampToDate(item.publish_date)"></td>
                        <td>
                            <span v-if="typeof(item.level) !== 'undefined'">{{item.level.title}}</span>
                        </td>
                        <td>{{item.amount_pupils}}</td>
                        <td>{{item.amount_winners}}</td>
                        <td>{{item.amount_prize_winners}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="7">Загрузка данных...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>
    </div>
</template>

<script>
    import Axios from 'axios'
    import _ from 'lodash'
    import {common} from '../mixins/common'
    export default {
        name: "EventsPupils",
        mixins: [common],
        data(){
            return{
                eventsPupils: false,
                isLoad: false,
            }
        },
        methods:{
            getEventsPupils() {
                if(!this.isLoad && !this.eventsPupils){
                    this.isLoad = true
                    const path = this.$store.state.api + this.$store.state.apiEventsPupils + "?eoId=" + this.$store.state.eoId
                    const $this = this
                    Axios({
                        method: 'get',
                        url: path
                    }).then((res) => {
                        if (
                            res.status == 200
                            && res.data.result == 'success'
                        ) {
                            $this.eventsPupils = _.filter(res.data.data, function (o) {
                                return (
                                    (typeof(o.projectType.altName) !== 'undefined')
                                    && (o.projectType.altName == $this.$store.state.type)
                                )
                            });
                        }
                    })
                }else{
                    this.isLoad = !this.isLoad
                }
            },
        }
    }
</script>

<style scoped>

</style>
